import { useCallback, useEffect, useRef, useState } from "react";
import { premiumError, premiumRequest } from "../../../services/Premium";

/** Odrzuca spóźnione odpowiedzi, w tym GET rozpoczęty przed świeższym zapisem. */
export default function usePremiumResource(token, path) {
  const [state, setState] = useState({
    key: null,
    data: null,
    error: "",
    loading: true,
  });
  const [refresh, setRefresh] = useState(0);
  const generation = useRef(null);
  const key = `${token}:${path}`;
  useEffect(() => {
    const current = Symbol();
    generation.current = current;
    const controller = new AbortController();
    setState({ key, data: null, error: "", loading: Boolean(path) });
    if (path)
      premiumRequest(token, path, { signal: controller.signal })
        .then((data) => {
          if (current === generation.current)
            setState({ key, data, error: "", loading: false });
        })
        .catch((error) => {
          if (current === generation.current && !controller.signal.aborted)
            setState({
              key,
              data: null,
              error: premiumError(error),
              loading: false,
            });
        });
    return () => {
      generation.current = null;
      controller.abort();
    };
  }, [token, path, key, refresh]);
  const replace = useCallback(
    (data) => {
      generation.current = null;
      setState({ key, data, error: "", loading: false });
    },
    [key],
  );
  const reload = useCallback(() => setRefresh((value) => value + 1), []);
  return {
    ...(state.key === key
      ? state
      : { data: null, error: "", loading: Boolean(path) }),
    replace,
    reload,
  };
}
